import { LicenseInfo } from "@mui/x-license";
import { AuthProvider } from "@app/auth/providers/AuthProvider";
import { ThemeProvider } from "@app/global/providers/ThemeProvider";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { sentryInit } from "./sentryInit";
import { StrictMode } from "react";
import relativeTime from "dayjs/plugin/relativeTime";
import isBetween from "dayjs/plugin/isBetween";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { UserMetadataProvider } from "./app/auth/providers/UserMetadataProvider";

// Set the license key for MUI X Pro packages before React renders the first component
LicenseInfo.setLicenseKey(import.meta.env.PUBLIC_MUI_LICENSE_KEY);

// Enable dayjs plugins
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(weekOfYear);

const rootEl = document.getElementById("root");
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <StrictMode>
      <AuthProvider>
        <ThemeProvider>
          <UserMetadataProvider>
            <App />
          </UserMetadataProvider>
        </ThemeProvider>
      </AuthProvider>
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
sentryInit();
reportWebVitals();
